import React, { ReactNode } from 'react';

import classNames from 'classnames';

import { TStepStatus } from '@/types/stepStatuses';

import CompletedTimelineStepIcon from '@/assets/icons/timeline/completed-step.svg?react';

import styles from './TimeLine.module.scss';
import { TimeLineItem } from './components';

import { TTimelineStepItem } from '@/shared/types';

type TTimeLineProps<TStepKey = string> = {
	onChangeStep?: (key: TStepKey) => void;
	activeTimelineStep: TStepKey;
	timelineOrder: TTimelineStepItem<TStepKey>[];
};

export const TimeLine = <TStepKey,>({
	onChangeStep,
	activeTimelineStep,
	timelineOrder,
}: TTimeLineProps<TStepKey>): ReactNode => {
	const activeStepIndex = timelineOrder.findIndex((step) => step.key === activeTimelineStep);

	const getStepsStatus = (activeIndex: number, stepIndex: number): TStepStatus => {
		if (activeIndex < stepIndex) {
			return 'not-active';
		}

		if (activeIndex === stepIndex) {
			return 'active';
		}

		return 'completed';
	};

	return (
		<div className={styles['time-line']} data-testid="timeline">
			{timelineOrder.map((step, index, array) => {
				const stepStatus: TStepStatus = getStepsStatus(activeStepIndex, index);

				const icon = stepStatus === 'completed' ? <CompletedTimelineStepIcon /> : step.icon;

				return (
					<React.Fragment key={step.key as string}>
						<TimeLineItem
							description={step.description}
							icon={icon}
							isActive={['active', 'completed'].includes(stepStatus)}
							title={step.title}
							onClick={() => onChangeStep?.(step.key)}
						/>

						{index !== array.length - 1 && (
							<div
								className={classNames(styles['divider'], {
									[styles['divider-completed']]: stepStatus === 'completed',
								})}
								data-testid={`timeline-divider-${index}`}
							></div>
						)}
					</React.Fragment>
				);
			})}
		</div>
	);
};
